<template>
    <div>
        <v-card elevation="0">
            <v-card color="#D4C88D" elevation="0" height="100px" class="d-flex align-content-end">
                <v-card-title class="white--text text-h5">
                    <v-icon color="white" large>mdi-chart-box-outline</v-icon>
                    &nbsp;Export
                </v-card-title>
            </v-card>
            <v-card-text>
                <Manager />
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import Manager from "../../../components/Admin/Export/Manager.vue"
export default {
    components: {
        Manager
    }
}
</script>